<template>
  <!-- 用户管理-箱子查询 -->
  <div class="query_box-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-date-picker
            v-model="query.start_time"
            type="datetime"
            placeholder="开始时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
          -
          <el-date-picker
            v-model="query.end_time"
            type="datetime"
            placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="query.user_id"
            placeholder="请输入用户uid"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="query.box_id"
            placeholder="请输入箱子id"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="query.name"
            placeholder="请输入箱子名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="query.type"
            placeholder="请选择箱子来源"
            @change="getData(1)"
          >
            <el-option
              v-for="item in sourceList"
              :key="item.value"
              :value="item.value"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="user_id" label="uid" align="center">
        </el-table-column>
        <el-table-column prop="box_id" label="箱子id" align="center">
        </el-table-column>
        <el-table-column prop="name" label="箱子名称" align="center">
        </el-table-column>
        <el-table-column prop="status" label="箱子状态" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.status == 1">已使用</span>
            <span v-if="row.status == 0">未使用</span>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="箱子来源" align="center">
          <template slot-scope="{ row }">
            <span>{{ getText(row.type) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="详情" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.remark ? row.remark : "无" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="发放时间" align="center">
        </el-table-column>
      </el-table>

      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'
import { query } from 'quill'

export default {
  data() {
    return {
      loading: false,//加载动画
      query: {
        page: 1,
        start_time: undefined,
        end_time: undefined,
        user_id: undefined,
        box_id: undefined,
        name: undefined,
      },
      sourceList: undefined,//箱子来源
      sourceFilterList: undefined,//箱子来源(筛选后的)
      dataList: undefined, //数据列表
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData(1)
    this.getDataList()
  },
  methods: {
    //箱子来源列表
    getDataList() {
      getApiData('user_exp_box_type').then(res => {
        if (res) {
          let arr1 = []
          let arr2 = []
          for (let item in res) {
            let num = Number(item)
            let obj = {
              value: num,
              name: res[item]
            }
            arr1.push(obj)
            if (
              num != 13
              && num != 14
              && num != 15
              && num != 16
              && num != 18
              && num != 19
              && num != 20
              && num != 21
              && num != 22
              && num != 23
              && num != 24
              && num != 25
              && num != 26
              && num != 27
              && num != 28
              && num != 29
              && num != 30
              && num != 32
              && num != 33
            ) {
              //排除一些带数字的来源名称
              arr2.push(obj)
            }
          }
          this.sourceList = arr1
          this.sourceFilterList = arr2
        }
      }).finally(() => {
      })
    },
    //获取数据
    getData(num) {
      if (num === 1) {
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData('user_exp_box', params).then(res => {
        if (res) {
          this.dataList = res.data
          this.dataMeta = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
    //匹配箱子来源备注
    getText(type) {
      let laiyuan = ''
      this.sourceList.forEach(element => {
        if (element.value == type) {
          laiyuan = element.name
          return
        }
      });
      if (laiyuan) {
        return laiyuan
      } else {
        return ''
      }
    },
    //导出
    handleExport() {
      let params = this.query

      http
        .post(
          api + 'user_exp_box_export',
          { ...params },
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '箱子查询数据.xlsx'
          })
        }).finally(() => {
        })
    },
  }

}
</script>
<style lang="less" scoped>
.debris_formula_config-box {
  header {
  }

  .body-box {
    // width: 800px;
  }
}
</style>